export const ListQueryKey = 'coupons';
export const DetailQueryKey = 'coupon';

export const Urls = {
  selectUrl: '/coupon/list',
  updateUrl: '/coupon/update',
  deleteUrl: '/coupon/delete',
  createUrl: '/coupon/create',
  detailUrl: '/coupon/detail',
};
